import { DynamicSelectProps, OptionType } from "@/src/common/types"
import useOnOutsideClick from "@/src/sb/hooks/useOnOutsideClick"
import React, { useRef, useState } from "react"

const DynamicSelect: React.FC<DynamicSelectProps> = ({
  options,
  value,
  onChange,
  placeholder = "Select an option",
  onClick,
  theme = "default"
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState<string | undefined>(value)
  const containerRef = useRef<HTMLDivElement>(null)

  const handleToggle = () => {
    if (!onClick) {
      setIsOpen(!isOpen)
    } else {
      onClick()
    }
  }

  const handleSelect = (option: OptionType) => {
    setSelectedValue(option.value)
    onChange && onChange(option.value)
    setIsOpen(false)
  }

  const handleClickOutside = () => {
    setIsOpen(false)
  }

  useOnOutsideClick(containerRef, handleClickOutside)

  return (
    <div className="relative" ref={containerRef}>
      <button
        type="button"
        onClick={handleToggle}
        className={`w-full py-2 px-2.5 text-xs text-gray-700 border-[0.5px] dark:border-[#4B5563]
          shadow-sm flex justify-between items-center
         focus:outline-none dark:text-gray-300 gap-2 font-normal ${
           theme === "custom"
             ? "dark:bg-[#1F2937] bg-stears_white"
             : "bg-[#1A1D21]"
         }`}
      >
        {selectedValue
          ? options?.find((option) => option.value === selectedValue)?.label
          : placeholder}
        <svg
          className="text-gray-500 dark:text-gray-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          height="12"
          width="12"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="absolute z-20 py-2 w-full border-[0.5px] shadow-lg dark:border-[#4B5563] dark:bg-[#1A1D21]  bg-stears_white">
          {options?.map((option, index) => (
            <button
              key={option.value}
              onClick={() => handleSelect(option)}
              className={`text-white block w-full px-5 py-2 text-xs font-normal hover:bg-gray-600 dark:hover:bg-gray-800 focus:outline-none text-left ${
                index === 3 ? "mb-2 border-b-[0.5px] dark:border-[#4B5563]" : ""
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default DynamicSelect
